module.exports = __webpack_public_path__ + "amcharts/images/lensWhite.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/lensWhite.svg
// module id = 273
// module chunks = 0